import './index.scss'
// import '../../assets/scripts/myNiceScroll'
// import {resizeScroll} from '../../assets/scripts/myNiceScroll'
import Swiper from 'swiper/swiper-bundle.min.js'

var swiper1 = new Swiper(".section3 .mySwiper", {
  slidesPerView: 1,
  slidesPerGroup: 1,
  spaceBetween: 10,
  breakpoints: {
    768: {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 20
    },
    1280: {
      slidesPerView: 3,
      slidesPerGroup: 3,
      spaceBetween: 30
    }
  },
  pagination: {
    el: ".section3 .swiper-pagination",
    clickable: true,
  }
})

var swiper2 = new Swiper(".section4 .mySwiper", {
  slidesPerView: 1,
  slidesPerGroup: 1,
  spaceBetween: 10,
  breakpoints: {
    768: {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 20
    },
    1280: {
      slidesPerView: 3,
      slidesPerGroup: 3,
      spaceBetween: 30
    }
  },
  pagination: {
    el: ".section4 .swiper-pagination",
    clickable: true,
  }
})